'use client'
import { Button, cn, Modal, ModalContent, ModalProps } from "@heroui/react"
import { useTranslations } from "next-intl"
import { mergeModalLayerClassNames, useModalLayer } from "@/ui/modalLayer"

export default ({
  isLoading,
  onConfirm,
  isOpen,
  classNames,
  ...props
}: Omit<ModalProps, 'children'> & {
  isLoading?: boolean
  onConfirm: () => void
}) => {
  const t = useTranslations()
  const layer = useModalLayer(isOpen)

  return (
    <Modal
      hideCloseButton
      placement="center"
      isOpen={isOpen}
      classNames={mergeModalLayerClassNames({
        ...classNames,
        wrapper: cn("overflow-visible", classNames?.wrapper),
        base: cn("max-w-[400px] bg-transparent shadow-none overflow-visible", classNames?.base),
      }, layer)}
      {...props}
    >
      <ModalContent className="overflow-visible bg-transparent shadow-none">
        {(onClose) => (
          <div className="relative pt-[104px]">
            <img
              src="/imgs/upgrade-membership.png"
              alt=""
              width={302}
              height={124}
              className="pointer-events-none absolute left-1/2 top-[-20px] z-10 -translate-x-1/2"
            />
            <div className="flex h-[320px] flex-col items-center rounded-[24px] border border-white/70 bg-gradient-to-b from-[#DEBDFF] via-white via-50% to-[#FDFBFF] px-9 pb-6 pt-8">
              <h2 className="text-center text-[20px] font-black capitalize leading-normal text-[#151030]">
                {t('pricing.upgradeMembershipTitle')}
              </h2>
              <p className="mt-6 text-center text-[16px] font-medium leading-6 text-[#151030]/[0.87]">
                {t('pricing.upgradeMembershipDesc')}
              </p>
              <Button
                fullWidth
                radius="full"
                isLoading={isLoading}
                className="mt-auto h-12 bg-gradient-to-l from-gradient-purple2 to-gradient-blue2 text-[16px] font-semibold capitalize text-theme-white"
                onPress={onConfirm}
              >
                {t('pricing.upgradeNow')}
              </Button>
              <button
                type="button"
                className="mt-5 text-[14px] font-medium capitalize text-black/40"
                onClick={onClose}
              >
                {t('common.cancel')}
              </button>
            </div>
          </div>
        )}
      </ModalContent>
    </Modal>
  )
}
